import { render, staticRenderFns } from "./GenerateLinkButton.vue?vue&type=template&id=4112d55f&scoped=true"
import script from "./GenerateLinkButton.vue?vue&type=script&lang=js"
export * from "./GenerateLinkButton.vue?vue&type=script&lang=js"
import style0 from "./GenerateLinkButton.vue?vue&type=style&index=0&id=4112d55f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4112d55f",
  null
  
)

/* custom blocks */
import block0 from "./GenerateLinkButton.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports